import { useTranslation } from "react-i18next"

function SuccessMessage({
    message = null
}) {

    const [t, i18n] = useTranslation(["global"])

    let content =
        <div>
            <div className="alert alert-success alert-dismissible" role="alert" key="unique">
                {message? message : t("global:helper.edit_success")}
                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
        </div>

    return content
}

export default SuccessMessage